import {Emitter} from '../emitter';

const evite = window.evite = window.evite || {};
const _history = window.history;

class History extends Emitter {
  get length() {
    return _history && _history.length || 0
  }

  get state() {
    return _history && _history.state || null;
  }

  back() {
    _history && _history.back();
  }

  forward() {
    _history && _history.forward();
  }

  go(index) {
    _history && _history.go(index);
    this.dispatchEvent(new CustomEvent('change'));
  }

  pushState(...args) {
    _history && _history.pushState.apply(_history, args);
    this.dispatchEvent(new CustomEvent('change'));
  }

  replaceState(...args) {
    _history && _history.replaceState.apply(_history, args);
    this.dispatchEvent(new CustomEvent('change'));
  }
}

export const history = new History();

Object.assign(evite, exports);



// WEBPACK FOOTER //
// ./assets/es6/common/evite/history.es6